import { render, staticRenderFns } from "./periodManger.vue?vue&type=template&id=6d77ffad&scoped=true"
import script from "./periodManger.vue?vue&type=script&lang=js"
export * from "./periodManger.vue?vue&type=script&lang=js"
import style0 from "./periodManger.vue?vue&type=style&index=0&id=6d77ffad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d77ffad",
  null
  
)

export default component.exports